import "@shoelace-style/shoelace/dist/components/icon/icon.js";
import React, { useRef } from "react";

/**
 * FileUploadField - Reusable file upload component
 *
 * @param {Object} props
 * @param {string} props.id - Input ID
 * @param {string} props.label - Field label
 * @param {Array} props.selectedFiles - Array of selected files
 * @param {Function} props.onChange - Change handler
 * @param {boolean} props.multiple - Allow multiple file selection
 * @param {string} props.className - Additional class names
 */
const FileUploadField = ({
  id,
  label,
  selectedFiles = [],
  onChange,
  multiple = true,
  className = "",
}) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      onChange(Array.from(e.target.files));
    }
  };

  return (
    <div className={className}>
      <label
        htmlFor={id}
        className="block text-sm font-medium text-gray-300 mb-1"
      >
        {label}
      </label>
      <div className="flex items-center">
        <input
          ref={fileInputRef}
          type="file"
          id={id}
          onChange={handleFileChange}
          className="hidden"
          multiple={multiple}
        />
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          className="px-4 py-2 bg-[#262b30] text-gray-300 rounded hover:bg-[#2f3236] focus:outline-none focus:ring-2 focus:ring-[#4db1e0] border border-[#2f3236]"
        >
          Choose Files
        </button>
        <span className="ml-2 text-sm text-gray-400">
          {selectedFiles.length > 0
            ? `${selectedFiles.length} file${selectedFiles.length === 1 ? "" : "s"} selected`
            : "No files selected"}
        </span>
      </div>

      {selectedFiles.length > 0 && (
        <div className="mt-2 space-y-1">
          {selectedFiles.map((file, index) => (
            <div
              key={index}
              className="text-xs text-gray-400 flex items-center"
            >
              <sl-icon name="file-earmark" class="mr-1"></sl-icon>
              {file.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FileUploadField;
